<template>
  <a-row class="flex-1 spinner-cnt" justify="center" type="flex">
    <a-spin size="large" />
  </a-row>
</template>

<script>
export default {}
</script>
